import { motion } from "framer-motion";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import AnimatedCounter from "./AnimatedCounter";

export const PnlTimeline = ({ data }) => {
  const series = data?.series || [];
  const empty = series.length === 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      className="panel lg:col-span-4 flex flex-col min-h-[240px]"
      data-testid="pnl-timeline-panel"
    >
      <div className="panel-header">
        <h3 className="font-display text-sm font-bold uppercase tracking-tight">
          Cumulative PnL Timeline
        </h3>
        <span className="label-micro">decision_log</span>
      </div>

      {!empty && (
        <div className="grid grid-cols-3 border-b border-border text-center">
          <Mini label="Peak" value={data.peak} />
          <Mini label="Current" value={data.current} />
          <Mini label="Drawdown" value={data.drawdown} tone="magenta" />
        </div>
      )}

      <div className="flex-1 min-h-[160px] p-2">
        {empty ? (
          <p className="text-sm text-text-secondary font-mono p-2">No decision_log entries yet.</p>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={series}>
              <defs>
                <linearGradient id="pnlFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="hsl(var(--accent-positive))" stopOpacity={0.35} />
                  <stop offset="100%" stopColor="hsl(var(--accent-positive))" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--chart-grid))" />
              <XAxis dataKey="round" tick={{ fontSize: 9 }} />
              <YAxis tick={{ fontSize: 9 }} />
              <Tooltip />
              <ReferenceLine y={0} stroke="hsl(var(--border))" />
              <Area type="monotone" dataKey="pnl" stroke="hsl(var(--accent-positive))" fill="url(#pnlFill)" />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </motion.div>
  );
};

const Mini = ({ label, value, tone }) => (
  <div className="p-2 border-r last:border-r-0 border-border">
    <div className="label-micro">{label}</div>
    <div className={`text-sm font-mono num ${tone === "magenta" ? "text-magenta" : "text-foreground"}`}>
      <AnimatedCounter value={value} decimals={2} duration={800} />
    </div>
  </div>
);

export default PnlTimeline;
